module.exports = __webpack_public_path__ + "img/logo_medium_yellow.e5096995.svg";